import { WorkspaceSizeThresholds } from "@/common/constants";
import { makeStyles, tokens } from "@fluentui/react-components";

export const useWrapUpStyle = makeStyles({
	container: {
		height: "60px",
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "center",

		[`@container workspacePanel (width < ${WorkspaceSizeThresholds.Medium}px) and (width > ${WorkspaceSizeThresholds.Small}px)`]:
			{
				justifyContent: "flex-end",
			},

		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Small}px)`]:
			{
				height: "120px !important",
			},
	},
	dropdown: {
		height: "32px",
		marginRight: "20px",
		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Small}px)`]:
			{
				marginRight: "16px",
				minWidth: "240px",
				height: "50px",
			},
	},
	wrapupLabel: {
		marginRight: "25px",
		marginLeft: "6px",
	},
	wrapupLabelDisposable: {
		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Small}px)`]:
			{
				display: "none",
			},
	},
	timer: {
		fontSize: tokens.fontSizeBase400,
		marginRight: "25px",
		height: "100%",

		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Small}px)`]:
			{
				marginRight: "16px",
			},
	},
	button: {
		marginRight: "5px",
	},
	actionableContainer: {
		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Small}px)`]:
			{
				flexDirection: "column !important",
				flexFlow: "column !important",
			},
	},
	timerAndButtons: {
		justifyContent: "flex-end !important",
		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Small}px)`]:
			{
				height: "60px",
				justifyContent: "space-between !important",
			},
	},
	buttonsContainer: {
		alignItems: "flex-end !important",
	},
});
